import { PHONE_NUMBER_IFINANCE, PHONE_NUMBER_LINK_IFINANCE } from '@applyonline/shared'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import useFaqLink from '../../hooks/useFaqLink'

interface Props {
  creditAppId: string
}

const VouchedPreparePage = ({ creditAppId }: Props) => {
  const { t } = useTranslation()
  const faqLink = useFaqLink()
  return (
    <main style={{ flexGrow: 1 }} className="step-0">
      <h1>{t('identityValidation.title')}</h1>
      <div className="paragraph" style={{ marginTop: '1rem', maxWidth: '100%' }}>
        <p>{t('identityValidation.thirdPartyExplanation')}</p>
      </div>
      <div className="box" style={{ maxWidth: '100%' }}>
        <div className="review-item" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <div className="box" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <div style={{ marginBottom: '2rem' }}>{t('identityValidation.whatYouNeed')}</div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: '2rem',
                width: '100%',
              }}
            >
              <i className="fa-light fa-address-card" style={{ marginRight: '1.5rem' }} />
              <span>{t('identityValidation.governmentID')}</span>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: '2rem',
                width: '100%',
              }}
            >
              <i className="fa-light fa-mobile" style={{ marginRight: '1.5rem' }} />
              <span>{t('identityValidation.phoneSelfie')}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="paragraph" style={{ marginTop: '1rem', maxWidth: '100%', fontSize: '1.2rem' }}>
        <p>{t('identityValidation.encryptedInfo')}</p>
      </div>
      <div className="box">
        <div className="box-content">
          <div className="text-center strong" style={{ marginTop: '1.5rem' }}>
            {t('eligibility.preApproved')}
          </div>
        </div>
      </div>
      <Link to={`/creditApplication/${creditAppId}/vouchedPage`} className="btn btn-blue">
        {t('identityValidation.button')}
      </Link>

      <section>
        <p style={{ marginTop: '2rem', fontSize: '1.2rem' }}>
          <Trans
            i18nKey="identityValidation.poweredBy"
            components={{
              site_anchor: <Link to="https://www.vouched.id/" target="_blank" />,
            }}
          />
        </p>
        <div style={{ fontSize: '1.5rem', marginTop: '1rem' }}>
          <Trans
            i18nKey="identityValidation.question"
            components={{
              site_anchor: <Link to={faqLink} target="_blank" />,
            }}
          />
          <div style={{ marginTop: '8px' }}>
            <Trans
              i18nKey="identityValidation.contactUs"
              values={{
                phoneNumber: PHONE_NUMBER_IFINANCE,
              }}
              components={{
                a: <Link to={PHONE_NUMBER_LINK_IFINANCE} style={{ textWrap: 'nowrap' }} />,
              }}
            />
          </div>
        </div>
      </section>
    </main>
  )
}

export default VouchedPreparePage
